import InfiniteScroll from './InfiniteScroll.component';

export default InfiniteScroll;
